import {
	FrameName,
	tilerepoCobbledRoadsFrameNames,
	tilerepoDirtRoadsFrameNames,
	tilerepoGrasslandFrameNames,
	tilerepoGravelRoadsFrameNames,
	tilerepoRoadsFrameNames,
} from "@/game/entities/config";

const PNG_EXT_REGEXP = /\.png$/i;

export const getFrameName = (frameName: FrameName): FrameName => {
	if (tilerepoGrasslandFrameNames.has(frameName))
		frameName = FrameName.GRASSLAND;

	if (tilerepoRoadsFrameNames.has(frameName)) {
		if (tilerepoDirtRoadsFrameNames.has(frameName))
			frameName = FrameName.DIRT_ROAD;
		else if (tilerepoGravelRoadsFrameNames.has(frameName))
			frameName = FrameName.GRAVEL_ROAD;
		else if (tilerepoCobbledRoadsFrameNames.has(frameName))
			frameName = FrameName.COBBLED_ROAD;
	}

	return frameName as FrameName;
};

export const getTileIconName = (frameName: FrameName): string => {
	return getFrameName(frameName).replace(PNG_EXT_REGEXP, "").toLowerCase();
};
